import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppContext from "../../context/Context";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Tooltip } from "antd";
import { NumericFormat } from 'react-number-format';

const useStyles = makeStyles((theme) => ({
  headingRow: {
    padding: "0.3rem 0 0.3rem 0",
    margin: "0 rem",
    background: ({ isDark }) => (isDark ? "#edf2f9" : "#edf2f9"),
  },
  mainPlusMin: {
    alignItems: "center",
    justifyContent: "flex-end",
    display: "flex",
    borderRadius: "0.25rem",
    background: ({ isDark }) => (isDark ? "#1A2639" : "#FFF"),
    height: "28px",
    border: ({ isDark }) => (`1px solid ${isDark ? '#2c3a52' : '#D9D9D9'}`),
    width: "100px",
    '& div': {
      width: "100%",
    }
  },
  inrDer: {
    padding: "5px 2px",
    margin: "0",
    lineHeight: "0",
    fontSize: "13px",
    borderRadius: "inherit",
    height: "28px",
    width: "23px",
    color: "#A1A1AA",
  },
  input: {
    textAlign: "center",
    padding: "4px",
    borderRadius: "0",
    width: "100%",
    margin: 0,
    borderRight: "none",
    borderLeft: "none",
    height: "28px",
  },
  fontText: {
    fontSize: "17px!important"
  }
}));

const PlusMinQty = ({
  qtyClick,
  filterValue,
  style,
  name,
  min,
  step,
  max,
  handleKeyDown,
  title,
  isModify,
  page,
  disabled,
  formatINR,
}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const classes = useStyles({ isDark });
  const [showControls, setShowControls] = useState(false);
  const [count, setCount] = useState(() => {
    const val = (filterValue === "" || filterValue == null) ? "" : filterValue.toString();
    return val;
  });

  useEffect(() => {
    const newVal = (filterValue === "" || filterValue == null) ? "" : filterValue.toString();
    const newFloat = parseFloat(newVal);
    const currFloat = parseFloat(count);

    if (!isNaN(newFloat) && !isNaN(currFloat)) {
      if (newFloat !== currFloat) setCount(newVal);
    } else if (count !== newVal) {
      setCount(newVal);
    }
  }, [filterValue]);

  const incrementCount = () => {
    if (disabled) return;
    const numericCount = parseFloat(count) || 0;
    const stepValue = parseFloat(step) || 1;
    let newCount = numericCount + stepValue;

    if (max !== undefined && max !== null && newCount > max) return;

    const precision = step?.toString().includes('.') ? step.toString().split('.')[1].length : 0;
    newCount = parseFloat(newCount.toFixed(precision));

    setCount(newCount.toString());
    qtyClick(newCount, filterValue);
  };

  const decrementCount = () => {
    if (disabled) return;
    const numericCount = parseFloat(count) || 0;
    const stepValue = parseFloat(step) || 1;
    let newCount = numericCount - stepValue;

    if (min !== undefined && min !== null && newCount < min) return;
    if (name === "maxLoss" && newCount > 0) return;
    if (name === "maxProfit" && newCount < 0) return;

    const precision = step?.toString().includes('.') ? step.toString().split('.')[1].length : 0;
    newCount = parseFloat(newCount.toFixed(precision));

    setCount(newCount.toString());
    qtyClick(newCount, filterValue);
  };

  const renderInput = () => {
    if (formatINR) {
      return (
        <NumericFormat
          value={count}
          thousandsGroupStyle="lakh"
          thousandSeparator=","
          decimalSeparator="."
          allowNegative={true}
          decimalScale={step?.toString().includes('.') ? step.toString().split('.')[1].length : undefined}
          isAllowed={(values) => {
            const { floatValue } = values;
            if (floatValue === undefined) return true;
            if (max != null && floatValue > max) return false;
            if (min != null && floatValue < min) return false;
            return true;
          }}
          onValueChange={(values) => {
            const raw = values.value;
            setCount(raw);
            if (values.floatValue !== undefined) {
              qtyClick(values.floatValue, filterValue);
            }
          }}
          customInput={Form.Control}
          className={classes.input + " qty_inp form-control"}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          name={name}
        />
      );
    }

    return (
      <Form.Group>
        <Form.Control
          value={count}
          name={name}
          type="number"
          className={classes.input + " qty_inp form-control"}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          onChange={({ target }) => {
            if (disabled) return;

            const rawValueStr = target.value;

            if (rawValueStr === "" || rawValueStr === "-") {
              setCount(rawValueStr);
              return;
            }

            let val = parseFloat(rawValueStr);
            if (isNaN(val)) return;

            let updatedStr = rawValueStr;
            if (max !== undefined && max !== null && val > max) { val = max; updatedStr = max.toString(); }
            if (min !== undefined && min !== null && val < min) { val = min; updatedStr = min.toString(); }

            setCount(updatedStr);
            qtyClick(val, filterValue);
          }}
        />
      </Form.Group>
    );
  };

  return (
    <Tooltip title={title || ""} placement="top">
      <div
        className={classes.mainPlusMin + " input-PM"}
        style={style}
        onMouseLeave={() => setShowControls(false)}
        onMouseEnter={() => setShowControls(true)}
      >
        {/* Decrement Button */}
        <button
          style={{
            backgroundColor: isDark ? "#1a2639" : "#FFF",
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            visibility: showControls ? "visible" : "hidden",
            pointerEvents: showControls ? "auto" : "none",
            border: "none",
            height: "26px",
          }}
          onClick={decrementCount}
          className={classes.inrDer}
          disabled={disabled}
        >
          <RemoveIcon className={classes.fontText} />
        </button>

        {renderInput()}

        {/* Increment Button */}
        <button
          style={{
            backgroundColor: isDark ? "#1a2639" : "#FFF",
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            visibility: showControls ? "visible" : "hidden",
            pointerEvents: showControls ? "auto" : "none",
            border: "none",
            height: "26px",
          }}
          onClick={incrementCount}
          className={classes.inrDer}
          disabled={disabled}
        >
          <AddIcon className={classes.fontText} />
        </button>
      </div>
    </Tooltip>
  );
};

export default PlusMinQty;